// 작은 메모리 캐시: 같은 요청은 TTL 동안 재사용하고, 동시에 들어온 같은 요청은 한 번만 보냅니다.
const store = new Map();
const MAX = 300;

export function cached(key, ttl, loader) {
  const hit = store.get(key);
  const now = Date.now();
  if (hit && (hit.pending || now - hit.at < ttl)) {
    store.delete(key); store.set(key, hit); // 최근 사용 순서 갱신
    return hit.promise;
  }
  const promise = loader().then(value => { store.set(key, { at: Date.now(), promise: Promise.resolve(value) }); return value; },
    error => { store.delete(key); throw error; });
  store.set(key, { at: now, promise, pending: true });
  promise.finally(() => { const item = store.get(key); if (item) item.pending = false; }).catch(() => {});
  while (store.size > MAX) store.delete(store.keys().next().value);
  return promise;
}
